export const PAYWALL_OFFER_TYPES = {
  OFFER: "Paywalls::Offer" as const,
  UPSELL: "Paywalls::Offers::Upsell" as const,
  BUMP: "Paywalls::Offers::Bump" as const,
};

export const PAYWALL_OFFER_SUBTYPES = {
  ADDON: "addon" as const,
  UPGRADE: "upgrade" as const,
};

export const PAYWALL_OFFER_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};
